
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"0","stroke-miterlimit":"10","fill":"none"}},[_c('path',{attrs:{"d":"M247.082 85.707c-17.352-49.08-64.118-84.258-119.13-84.3h-.19c-55.012.042-101.782 35.22-119.13 84.3a126.137 126.137 0 00-7.225 42.15c0 14.783 2.562 28.965 7.224 42.15 17.363 49.107 64.172 84.3 119.226 84.3s101.862-35.193 119.225-84.3a126.208 126.208 0 007.225-42.15c0-14.784-2.56-28.963-7.225-42.15z","fill":"#f31930"}}),_c('path',{attrs:{"d":"M119.713 176.56c-27.366 0-49.551-21.806-49.551-48.706s22.185-48.706 49.551-48.706a49.75 49.75 0 0136.991 16.377c-10.956-17.147-30.356-28.553-52.477-28.553-34.209 0-61.938 27.257-61.938 60.885s27.73 60.884 61.938 60.884c22.13 0 41.535-11.414 52.488-28.572a49.737 49.737 0 01-37.002 16.39zM178.229 99.414l-.5 22.505-20.997 5.702 20.699 7.37-.5 20.64 13.499-16.119 20.397 7.076-11.799-17.295 14.399-17.2-22.098 6.092-13.1-18.771z","fill":"#f3f4f5"}})])])
          )
        }
      }
    